// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width: 1024px){[data-v-63e360fa] .column-left{margin-top:350px}[data-v-63e360fa] .column-left>div{top:-350px}[data-v-63e360fa] .column-right{margin-top:90px}[data-v-63e360fa] .review-collab{font-size:22px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
